import { AdministratorDto } from '@/src/models/AdministratorDto';
import { Media } from '@/src/models/MeidaDto';
import { CreditTemplateDto } from '@/src/models/CreditTemplateDto';
import { CustomersDto } from '@/src/models/CustomersDto';

type MagazineType = 'common' | 'advertising';

export class MagazineDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  magazineType: MagazineType;
  title: string;
  subTitle: string;
  magazinePostStartedAt: string;
  magazinePostEndedAt: string;
  isExposed: boolean;
  awardedCreditYn: boolean;
  writerName?: string;
  sponsorPageLink?: string;
  sponsorDescription?: string;
  contents: string;
  priorityDisplayYn: boolean;
  administrator: AdministratorDto;
  creditTemplate?: CreditTemplateDto;
  thumbnailImage: Media;
  sponsorImage: Media;
  magazineViewHistoryCount: number;
  magazineBookmarkCount: number;
  bottomButtonDisplayYn: boolean;
  bottomButtonName?: string;
  bottomButtonLink?: string;
}

export class MagazineViewCustomerHistoryDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  gotCredit: number;
  gotCreditAt: string;
  customer: CustomersDto;
  magazine: MagazineDto;
}
